export enum Breed {
	Mixed = "Mixed",
	AmericanStaffordshireTerrier = "AmericanStaffordshireTerrier",
	AustralianCattledog = "AustralianCattledog",
	AustralianKelpie = "AustralianKelpie",
	AustralianShepherd = "AustralianShepherd",
	Bauceron = "Bauceron",
	BergerdesPyrenees = "BergerdesPyrenees",
	BohemianShepherd = "BohemianShepherd",
	BorderColie = "BorderColie",
	BorderTerrier = "BorderTerrier",
	Boxer = "Boxer",
	ChiendeBergerBelgeMalinois = "ChiendeBergerBelgeMalinois",
	ChiendeBergerBelgeTervueren = "ChiendeBergerBelgeTervueren",
	Dobermann = "Dobermann",
	EnglishSetter = "EnglishSetter",
	FoxTerier = "FoxTerier",
	GermanShepherd = "GermanShepherd",
	GoldenRetriever = "GoldenRetriever",
	HollandseHerdershond = "HollandseHerdershond",
	JackRusselTerrier = "JackRusselTerrier",
	Kooikerhondje = "Kooikerhondje",
	LabradorRetriever = "LabradorRetriever",
	LouisianaCatahoula = "LouisianaCatahoula",
	MiniatureAmericanShepherd = "MiniatureAmericanShepherd",
	Mudi = "Mudi",
	Novascottiaducktollinretriever = "Novascottiaducktollinretriever",
	ParsonRussellTerrier = "ParsonRussellTerrier",
	Pitbull = "Pitbull",
	Rhodesianridgeback = "Rhodesianridgeback",
	Rottweiler = "Rottweiler",
	RoughCollie = "RoughCollie",
	RovidszoruMagyarViszla = "RovidszoruMagyarViszla",
	Saluki = "Saluki",
	Sheltie = "Sheltie",
	StaffordshireBullterrier = "StaffordshireBullterrier",
	WelshCorgi = "WelshCorgi",
	Whippet = "Whippet",
}
